import React from 'react';
import styled from 'styled-components';
import github from '!!svg-inline-loader?classPrefix!src/assets/github.svg';

const NameLink = styled.a`
  letter-spacing: 0.15em;
`;

const GithubLogo = styled.span`
  width: 2.25rem;
  height: 2.25rem;
`;

const Header: React.FC = () => {
  return (
    <div className="bg-default">
      <div className="pt-2">
        <nav className="py-2 px-4 flex items-center">
          <div>
            <NameLink
              href="/"
              className="text-font-default uppercase tracking-wider font-title text-lg font-extrabold"
            >
              Means88
            </NameLink>
          </div>
          <ul className="ml-auto">
            <li className="nav-github">
              <a href="https://github.com/Means88">
                <GithubLogo
                  className="inline-block fill-current btn-hover-reverse"
                  dangerouslySetInnerHTML={{
                    __html: github,
                  }}
                />
              </a>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  );
};

export default Header;
